class ThemeFocusTrap {
  constructor(container, options = {}) {
    this.container = container;
    this.onEscape = options.onEscape;
    this.initialFocus = options.initialFocus;
    this.trigger = null;
    this.active = false;
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  getFocusableElements() {
    if (!this.container) return [];

    return Array.from(this.container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((element) => (
      !element.hidden
      && element.getAttribute('aria-hidden') !== 'true'
      && element.getClientRects().length > 0
    ));
  }

  activate(trigger = document.activeElement) {
    if (!this.container) return;
    if (this.active) return;

    this.trigger = trigger instanceof HTMLElement ? trigger : null;
    this.active = true;
    document.addEventListener('keydown', this.handleKeydown);

    requestAnimationFrame(() => {
      const preferredFocus = typeof this.initialFocus === 'string'
        ? this.container.querySelector(this.initialFocus)
        : this.initialFocus;
      const focusTarget = preferredFocus || this.getFocusableElements()[0] || this.container;

      if (!focusTarget.hasAttribute('tabindex') && focusTarget === this.container) {
        focusTarget.setAttribute('tabindex', '-1');
      }

      focusTarget.focus();
    });
  }

  deactivate({ restoreFocus = true } = {}) {
    if (!this.active) return;

    this.active = false;
    document.removeEventListener('keydown', this.handleKeydown);

    if (restoreFocus && this.trigger?.isConnected) {
      this.trigger.focus();
    }

    this.trigger = null;
  }

  handleKeydown(event) {
    if (!this.active) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      this.onEscape?.();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = this.getFocusableElements();
    if (!focusable.length) {
      event.preventDefault();
      this.container.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

window.ThemeFocusTrap = ThemeFocusTrap;
